module.exports = __webpack_public_path__ + "static/media/news1.388a23f4.png";